import {AfterViewInit, ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import {NotificationMessageService} from './notifications-message.service';
import {NotificationMessageTypes} from "@ispm/core/constants/notification-message-types.constant";

@Component({
  selector: 'gen-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss']
})

export class NotificationMessageComponent implements AfterViewInit {
  @ViewChild('messageTemplate') messageTemplate: TemplateRef<any>;

  constructor(
    public notificationMessageService: NotificationMessageService,
    private cd: ChangeDetectorRef
  ) {
  }

  ngAfterViewInit() {
    this.notificationMessageService.setHtmlTemplate(this.messageTemplate);
    this.cd.detectChanges();
  }

  public closeNotification(message) {
    this.notificationMessageService.closeNotification(message);
  }

  public doButtonAction = (action, message) => {
    if (action && typeof action === 'function') {
      action();
      this.closeNotification(message);
    }
  }

  public getDivHeight(): any {
    if (this.notificationMessageService.detectChange) {
      this.notificationMessageService.detectChange = false;
      this.cd.detectChanges();
    }

    let headerHeight = document.querySelector(".pt-header-text").getBoundingClientRect().height;
    let bodyHeight = document.querySelector(".pt-messsage-body").getBoundingClientRect().height;
    return headerHeight + bodyHeight;
  }

  protected readonly NotificationMessageTypes = NotificationMessageTypes;
}
